import { Link } from "react-router-dom";
import { Gamepad2, Users } from "lucide-react";

export default function BottomNav() {
  const navItems = [
    { href: "/", label: "Games", icon: Gamepad2 },
    { href: "/friends", label: "Friends", icon: Users },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-surface border-t border-border z-50 flex items-center px-4 py-1.5 min-h-[48px]">
      <div className="flex gap-3 flex-shrink-0">
        {navItems.map((item) => {
          const Icon = item.icon;

          return (
            <Link
              key={item.href}
              to={item.href}
              className="bg-foreground rounded-xl px-3 py-1.5 flex flex-col items-center gap-0.5 text-surface active:opacity-80"
            >
              <Icon className="h-[clamp(16px,4.5vw,20px)] w-[clamp(16px,4.5vw,20px)]" />
              <span className="font-emphasis text-[clamp(8px,2.2vw,10px)] font-semibold uppercase-tracked tracking-oswald-normal">
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
      <div className="flex-1 text-right">
        <p className="text-[11px] text-muted-foreground font-body leading-tight">© {currentYear} Imagine Sports</p>
        <p className="text-[11px] text-muted-foreground font-body leading-tight">
          <a href="#" onClick={(e) => e.preventDefault()} aria-disabled="true" className="hover:underline">Terms of Service</a>
          {" | "}
          <a href="#" onClick={(e) => e.preventDefault()} aria-disabled="true" className="hover:underline">Privacy Policy</a>
        </p>
      </div>
    </nav>
  );
}